import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from "react-router-dom";

import * as Utils from './common/utils';
import './index.less';
import * as serviceWorker from './serviceWorker';

import PageHome from './pages/home';
import PageCompany from './pages/company';
import PageCompanyList from './pages/companylist';
import PageEquipment from './pages/equiment';
import PageAdmin from './pages/admin';
import PageAdminUpKeep from './pages/adminupkeep';
import PageAdminUser from './pages/adminuser';
import PageUser from './pages/user';
import PageDevices from './pages/device';
import PageShops from './pages/shops';
import PageWork from './pages/work';
import PageKeep from './pages/upkeep';
import PageCompanyUpkeep from './pages/companyupkeep';
import PageKeepList from './pages/upkeeplist';
import PageAllCompany from './pages/allcompany';
import PageAllEquipment from './pages/allequiment';
import PageAllData from './pages/alldata';
import PageAdminCompanyList from './pages/admincompanylist';
import PageUpkeepDetail from './pages/upkeepdetail';
import PageUpkepInfo from './pages/upkeepinfo';
import PageAllTab from './pages/alltab';
import PageAllequipmentdetail from './pages/allequipmentdetail';
import PageAllUpkeepTab from './pages/allupkeeptab';
import PageAllUpkeepInfoDetail from './pages/allupkeepinfodetail';
import PageAdminupkeeplist from './pages/adminupkeeplist';



const App = () => (
	<Router>
		<div>
			<Route exact path="/" component={PageHome} />
			<Route exact path="/company/:id" component={PageCompany} />
			<Route exact path="/companylist" component={PageCompanyList} />
			<Route exact path="/equipment" component={PageEquipment} />
			<Route exact path="/admin" component={PageAdmin} />
			<Route exact path="/adminupkeep" component={PageAdminUpKeep} />
			<Route exact path="/adminuser" component={PageAdminUser} />
			<Route exact path="/work" component={PageWork} />
			<Route exact path="/upkeep" component={PageKeep} />
			<Route exact path="/upkeeplist/:type" component={PageKeepList} />
			<Route exact path="/companyupkeep" component={PageCompanyUpkeep} />
			<Route exact path="/user" component={PageUser} />
			<Route exact path="/devices/:id/:userId" component={PageDevices} />
			<Route exact path="/shops" component={PageShops} />
			<Route exact path="/allcompany" component={PageAllCompany} />
			<Route exact path="/alleuipment" component={PageAllEquipment} />
			<Route exact path="/alldata" component={PageAllData} />
			<Route exact path="/admincompanylist" component={PageAdminCompanyList} />
			<Route exact path="/upkeepdetail/:id" component={PageUpkeepDetail} />
			<Route exact path="/upkeepinfo/:id" component={PageUpkepInfo} />
			<Route exact path="/alltab" component={PageAllTab} />
			<Route exact path="/allupkeeptab" component={PageAllUpkeepTab} />
			<Route exact path="/allequipmentdetail/:id" component={PageAllequipmentdetail} />
			<Route exact path="/allupkeepinfodetail/:id" component={PageAllUpkeepInfoDetail} />
			<Route exact path="/adminupkeeplist/:type" component={PageAdminupkeeplist} />
		</div>  
	</Router>
);

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();

Utils.user.wxLogin({}, () => window.location.reload());

//微信 JS-SDK（录音等能力）只在微信浏览器内可用，其他浏览器跳过签名
if(Utils.getUA().isInWechat) {
	Utils.user.wxsign();
}

